var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tagList",staticClass:"car-tag-list",class:_vm.theme,style:({ maxHeight: _vm.height, ..._vm.listStyle })},_vm._l((_vm.tags),function(tag){return _c('div',{staticClass:"car-tag",class:{ ['type_' + tag.type]: true, [_vm.theme]: true }},[_c('span',[_vm._v(_vm._s(tag.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }